export const SHORT_DAYS_OF_WEEK_UPPER_RU = ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс'];
export const SHORT_DAYS_OF_WEEK_UPPER_EN = ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'];
export const SHORT_DAYS_OF_WEEK_UPPER_IT = ['Lu', 'Ma', 'Me', 'Gi', 'Ve', 'Sa', 'Do'];
export const SHORT_DAYS_OF_WEEK_UPPER_DE = ['Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa', 'So'];
export const SHORT_DAYS_OF_WEEK_UPPER_ES = ['Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sá', 'Do'];
export const SHORT_DAYS_OF_WEEK_UPPER_ZH = ['周一', '周二', '周三', '周四', '周五', '周六', '周日'];

export const START_DATE = 'startDate';
export const END_DATE = 'endDate';
export const RT = 'RT';
export const OW = 'OW';
